module.exports = __webpack_public_path__ + "static/media/little_girl.77fc01bc.png";